<div class="wrapper">
    
    <app-sidebar [page]="7"></app-sidebar>
    
    <div class="w-100">
        <app-top-bar></app-top-bar>

        <div class="card">

            <!-- title and export -->
            <div class="header">
                
                <div class="title">
                    <app-svg class="title-svg" 
                        width="30px"
                        height="30px"
                        color="#ef182e"
                        src="assets/svg/user-list.svg">
                    </app-svg>
                <h2>Users</h2>              
                </div>
                
                <button (click)="exportUserList()">
                    <svg id="Layer_1" data-name="Layer 1" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500"><defs><style>.cls-1{fill:none;}</style></defs><path class="cls-1" d="M106.8,134.48H357.4a24.52,24.52,0,1,0,0-49H106.8a24.52,24.52,0,0,0,0,49Z"/><path d="M106.8,382.36a24.52,24.52,0,0,1,0-49h70.63A169.35,169.35,0,0,1,201,258.42H106.8a24.52,24.52,0,0,1,0-49H245a170.42,170.42,0,0,1,211.52,5.29V67.15A57.66,57.66,0,0,0,398.85,9.5H65.35A57.66,57.66,0,0,0,7.69,67.15v333.5a57.66,57.66,0,0,0,57.66,57.66H219.58A169.93,169.93,0,0,1,181,382.36Zm0-296.91H357.4a24.52,24.52,0,1,1,0,49H106.8a24.52,24.52,0,0,1,0-49Z"/><path d="M456.51,250.26A144.9,144.9,0,0,0,203,333.32q-.51,6.07-.52,12.29a144.9,144.9,0,1,0,254-95.35ZM422.1,383a24.52,24.52,0,1,1-49,0V355.53l-26.82,26.83L314.58,414a24.52,24.52,0,0,1-37.23-31.67,24.84,24.84,0,0,1,2.55-3l46-46,14.27-14.27H312.79a24.52,24.52,0,1,1,0-49H422.1Z"/></svg>
                    <span>Export CSV</span>
                </button>
                
            </div>

                <div class="filter-list">

                    <!-- WEB SEARCH FILTER -->
                    <app-filter-search-bar
                        *ngIf="!isMobile"
                        [searchValue] = "searchValue"
                        (updateSearchValue) = "updateSearchValue($event)"
                    ></app-filter-search-bar>
                    
                    <!--  clear button -->
                    <div class="search-n-clear">
                        <button 
                            *ngIf="!isMobile"
                            (click)="clearAllFilters()" 
                            type="button" 
                            class="btn btn-outline-primary">
                            <span>Clear</span>
                        </button>
                    </div>

                    <!-- Territorial Partner Username filter -->
                    <app-classification-filter
                        class="classification-filter"
                        (updateClassificationFilter)="updateClassificationFilter($event)"
                        [classificationFilterItems]="updateClassificationFilterItems()">
                    </app-classification-filter>
                    
                </div>

            <div *ngIf="parentHierarchy.length > 0" class="display-hierarchy">
                <div *ngFor="let user of parentHierarchy; index as i">
                    <div> 
                        <span *ngIf="i > 0"> > </span> 
                        <div class="parent-name-div"> {{user.userLevel}} : {{user.username}} </div> 
                    </div>
                </div>
            </div>
        </div>
        
        
        <div *ngIf="parentHierarchy.length > 0" class="back-button">
            <button (click)="returnToHigerLevel()"> 
                <app-svg class="svg" 
                    width="15px"
                    height="25px"
                    color="white"
                    src="assets/svg/arrow_left.svg">
                </app-svg>
                <span> Back </span> 
            </button>
        </div>

        <app-user-list-table
            (updateSort)="updateSort($event)"
            [isLoading]="isLoading"
            [message]="message"
            [userList]="userListData"
            (onItemClickEmitter)="onSelectTableRow($event)"
        />

        <div 
        class="pagination"
        *ngIf="!isTotal && !isTotal">
            
            <button (click)="updatePage(current_page - 1)" *ngIf="(current_page - 1) >= 1" > 
                <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 500 500"><path d="M151.27,214.64,341.41,24.51a25,25,0,1,1,35.35,35.36L186.63,250,376.76,440.13a25,25,0,1,1-35.35,35.36L151.27,285.36,115.92,250Z"/></svg>
                <span>Prev</span>
            </button>
    
            <button (click)="updatePage(1)"  class="pagination-btn"  *ngIf="(current_page - 3) >= 1"> 1 </button>
            <span *ngIf="(current_page - 3) >= 1"n> ... </span>
            
            <button (click)="updatePage(current_page - 2)" class="pagination-btn" *ngIf="(current_page - 2) >= 1" >{{ current_page - 2 }}</button>
            <button (click)="updatePage(current_page - 1)" class="pagination-btn" *ngIf="(current_page - 1) >= 1" >{{ current_page - 1 }}</button>
            <button >{{ current_page }}</button>
            <button (click)="updatePage(current_page + 1)" class="pagination-btn" *ngIf="(current_page + 1) <= total_page" >{{ current_page + 1 }}</button>
            <button (click)="updatePage(current_page + 2)" class="pagination-btn" *ngIf="(current_page + 2) <= total_page" >{{ current_page + 2 }}</button>
            
            <span *ngIf="(current_page + 3) <= total_page"> ... </span>
            <button (click)="updatePage(total_page)"  class="pagination-btn" *ngIf="(current_page + 3) <= total_page">{{ total_page }}</button>
            
            <button (click)="updatePage(current_page + 1)" *ngIf="(current_page + 1) <= total_page"> 
                <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 500 500"><path d="M348.73,214.64,158.59,24.51a25,25,0,1,0-35.35,35.36L313.37,250,123.24,440.13a25,25,0,1,0,35.35,35.36L348.73,285.36,384.08,250Z"/></svg>
                <span>Next</span>
            </button>
    
        </div>

    </div>

    <app-message-modal/>


</div>